import StaffAvailabilityTab from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/StaffAvailabilityTab";
import { withTranslation } from "react-i18next";

const OfficeSchedule = ({
  staffAvailFiltersData,
  staffAvailabilityViewSelectedFromDashBoard,
  currentDateFromDashBoard,
  setCurrentDateFromDashBoard,
  appliedAgendaTypes,
  appliedViewSettig,
  appliedOfficeFilters,
  isEnterpriseFilterActive,
}) => {
  return (
    <StaffAvailabilityTab
      staffAvailFiltersData={staffAvailFiltersData}
      isFromDashBoard={true}
      staffAvailabilityViewSelectedFromDashBoard={
        staffAvailabilityViewSelectedFromDashBoard
      }
      currentDateFromDashBoard={currentDateFromDashBoard}
      setCurrentDateFromDashBoard={setCurrentDateFromDashBoard}
      appliedAgendaTypes={appliedAgendaTypes}
      appliedViewSettig={appliedViewSettig}
      appliedOfficeFilters={appliedOfficeFilters}
      isEnterpriseFilterActive={isEnterpriseFilterActive}
    />
  );
};

export default withTranslation()(OfficeSchedule);
